/// <amd-module name="Repos/Tfvc/Views/ShelvesetsHub/Components/ShelvesetsTable" />
import * as React from "react";
import * as Resources from "Repos/Tfvc/Views/ShelvesetsHub/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { onClickFPS } from "VSS/Platform/FPS";
import { VssComponent } from "VSS/Platform/Layout";
import { Ago } from "VSSUI/Ago";
import { IBasicIdentityRef, Persona, PersonaSize } from "VSSUI/Persona";
import { ITableColumn, ITableRow, Table, TableColumnLayout, TwoLineTableCell } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { AgoFormat } from "VSSUI/Utilities/Date";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { IShelveset } from "../ShelvesetsListDataProviderService";

export interface ShelvesetsTableProps {
    shelvesets: (IShelveset | undefined)[];
    showHeader?: boolean;
}

export class ShelvesetsTable extends VssComponent<ShelvesetsTableProps> {
    private commentColumn: ITableColumn<IShelveset> = {
        columnLayout: TableColumnLayout.twoLine,
        id: "comment",
        renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IShelveset>, tableItem: IShelveset) => {
            const line1 = (
                <Tooltip className="text-ellipsis font-weight-semibold flex-row flex-grow" overflowOnly={true} text={tableItem.comment}>
                    <div className="text-ellipsis font-weight-semibold flex-grow">{tableItem.shelvesetName}</div>
                </Tooltip>
            );

            const identity = {
                id: tableItem.ownerId,
                displayName: tableItem.ownerDisplayName,
                imageUrl: tableItem.ownerRef?.imageUrl
            } as IBasicIdentityRef;

            const line2 = (
                <div className="flex-row flex-center body-s secondary-text rhythm-horizontal-8 scroll-hidden">
                    <div className="flex-row flex-center scroll-hidden rhythm-horizontal-4">
                        <Persona identity={identity} size={PersonaSize.size16} />
                        <Tooltip overflowOnly={true}>
                            <div className="text-ellipsis">{tableItem.ownerDisplayName}</div>
                        </Tooltip>
                    </div>
                    <div className="flex-row flex-center scroll-hidden">
                        <Ago date={tableItem.creationDate} format={AgoFormat.Extended} />
                    </div>
                </div>
            );

            return (
                <TwoLineTableCell
                    className="repos-shelvesets-table-content"
                    columnIndex={columnIndex}
                    key={columnIndex}
                    tableColumn={tableColumn}
                    line1={line1}
                    line2={line2}
                />
            );
        },
        minWidth: 200,
        name: Resources.ShelvesetHeader,
        width: new ObservableValue(-100)
    };

    public render() {
        const tableColumns: ITableColumn<IShelveset>[] = [this.commentColumn];

        return (
            <Table<IShelveset | undefined>
                className="repos-shelvesets-table"
                columns={tableColumns}
                itemProvider={new ArrayItemProvider(this.props.shelvesets)}
                onActivate={(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<IShelveset>) => {
                    if (!event.defaultPrevented) {
                        onClickFPS(this.context.pageContext, tableRow.data.linkProps.href!, true, event);
                    }
                }}
                selectableText={true}
                showHeader={!!this.props.showHeader}
            />
        );
    }
}
